import { Injectable } from '@angular/core';
import { SalesByClientsExportQuery, SalesByClientsExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByClientsExportQuery)
@Wrapper(SalesByClientsExportQueryHandlerBase)
export class SalesByClientsExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
